import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-dynamic-breadcrumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
  })
export class BreadcrumbComponent implements OnInit {
  @Input() bgColor: string = 'transparent';
  @Input() fontSize: string = '14px';
  @Input() lastLinkColor: string = 'rgba(196, 196, 205, 0.42)';
  @Input() fontColor: string = '#c4c4cd';
  items: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.items = this.buildBreadCrumb(this.route.root);
    });
  }

  ngOnInit(): void {
    // Ensure breadcrumb is available on initial page load, not only after navigation events.
    this.items = this.buildBreadCrumb(this.route.root);
  }

  buildBreadCrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: any[] = [],
    routeParams: Record<string, string> = {},
  ): any[] {
    let children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (let child of children) {
      const mergedParams: Record<string, string> = {
        ...routeParams,
        ...(child.snapshot?.params || {}),
      };

      if (child.routeConfig && child.routeConfig.data && child.routeConfig.data['breadcrumb']) {
        const bc = child.routeConfig.data['breadcrumb'];
        if (Array.isArray(bc)) {
          bc.forEach(crumb => {
            const label = this.resolvePlaceholders(crumb.label, mergedParams);
            const resolvedUrl = this.resolvePlaceholders(crumb.url || '', mergedParams);
            const existingItem = breadcrumbs.find(x => x.label === label);

            if (!existingItem) {
              breadcrumbs.push({
                label,
                routerLink: resolvedUrl ? [resolvedUrl] : null
              });
            } else if (!existingItem.routerLink && resolvedUrl) {
              existingItem.routerLink = [resolvedUrl];
            }
          });
        }
      }
      return this.buildBreadCrumb(child, url, breadcrumbs, mergedParams);
    }
    return breadcrumbs;
  }

  private resolvePlaceholders(template: string, routeParams: Record<string, string>): string {
    if (!template) {
      return '';
    }

    return template
      .replace(/\{\{\s*([^\}]+)\s*\}\}/g, (_, key) => routeParams[key]?.toString() || '')
      .replace(/:([A-Za-z0-9_]+)/g, (_, key) => routeParams[key]?.toString() || `:${key}`);
  }
}